module.exports = __webpack_public_path__ + "8ff17040ad8b659be8a64948ef4e4b75.svg";